import { Checkbox, Form } from "antd";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface Props<TSchema extends FieldValues> {
  name: Path<TSchema>; // Allow only field names (string) that are listed into the Schema
  label?: string;
  placeholder: string;
  errorMessage?: string;
  control: Control<TSchema>;
  isVertical?: boolean;
}

export default function FieldCheckbox<TSchema extends FieldValues>(
  props: Props<TSchema>,
) {
  const { name, label, errorMessage, control, isVertical } = props;
  return (
    <Form.Item
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage || null}
      label={label}
      layout={isVertical ? "vertical" : "horizontal"}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Checkbox checked={field.value} onChange={field.onChange} />
        )}
      />
    </Form.Item>
  );
}
